import { IDaySettingPartial } from '../../../app/entities/DaySetting'

export function runRouteOptimizationForLocation(
  date: Date,
  locationId?: string,
) {
  return {
    method: 'POST',
    url: `${process.env.REACT_APP_ORIGIN}/test/route-optimization`,
    body: {
      date: date.toISOString().split('T')[0],
      locationId,
    },
  }
}

export function testORTools(body: { locationId: string; date: number }) {
  return {
    method: 'POST',
    url: `${process.env.REACT_APP_ORIGIN}/jmullet-tools/test-or-tools`,
    body,
  }
}

export const getOrderByWorkOrderId = (workOrderId: number) => {
  return {
    method: 'GET',
    url: `${process.env.REACT_APP_ORIGIN}/jmullet-tools/order-by-work-order-id?workOrderId=${workOrderId}`,
  }
}

export const addCompletedInvoice = (body: any) => {
  return {
    method: 'POST',
    url: `${process.env.REACT_APP_ORIGIN}/jmullet-tools/add-completed-invoice`,
    body,
  }
}

export const getDriveTimeDetails = (
  locationObjectId: string,
  fromDate: string,
  toDate: string,
) => {
  return {
    method: 'GET',
    url: `${process.env.REACT_APP_ORIGIN}/jmullet-tools/drive-time-details?locationObjectId=${locationObjectId}&fromDate=${fromDate}&toDate=${toDate}`,
  }
}

export const updateRoutingAlgorithm = (
  routingAlgorithm: string,
  locationObjectId: string,
) => {
  return {
    method: 'PUT',
    url: `${process.env.REACT_APP_ORIGIN}/jmullet-tools/update-routing-algorithm`,
    body: { routingAlgorithm, locationObjectId },
  }
}

export const reverseLocationConversion = (locationObjectId: string) => {
  return {
    method: 'POST',
    url: `${process.env.REACT_APP_ORIGIN}/jmullet-tools/reverse-location-conversion`,
    body: { locationObjectId },
  }
}

export const getActiveTechniciansForLocation = (locationId: string) => {
  return {
    method: 'GET',
    url: `${process.env.REACT_APP_ORIGIN}/jmullet-tools/location/${locationId}/active-technicians`,
  }
}

export function testScheduleChangeImpact(
  technicianObjectId: string,
  proposedDaySetting: IDaySettingPartial,
) {
  return {
    method: 'POST',
    url: `${process.env.REACT_APP_ORIGIN}/jmullet-tools/test-schedule-change-impact`,
    body: {
      technicianObjectId,
      proposedDaySetting,
    },
  }
}

export const triggerDaySettingsMaintenance = () => {
  return {
    method: 'POST',
    url: `${process.env.REACT_APP_ORIGIN}/jmullet-tools/trigger-day-settings-maintenance`,
  }
}
